module.exports = __webpack_public_path__ + "f3662b1af1b699dbdf2b3458a6f98776.png";